import React from "react";
import {FlexCol} from "../components/generic/Containers";
import {Footer} from "../components/Footer";
import {LandingPagedHeader} from "../components/landingPage/LandingPageHeader";
import {ContentTypesOverview, LearnFromExperts} from "../components/DashboardMainMenus";
import {HeroBanner} from "../components/landingPage/HeroBanner";
import {LandingPageOverviewSections} from "../components/landingPage/LandingPageOverviewComponent";
import {TestimonialsComponent} from "../components/landingPage/TestimonialsComponent";

export const EducatorsPage: React.FC<{navigate?: any}> = ({navigate}) => {
    return (
        <FlexCol padding={0} heightPercent={100} widthPercent={100}>
            <LandingPagedHeader isEducator={true}/>
            <FlexCol widthPercent={100} gap={2}>
                <HeroBanner isEducator={true} />
                <FlexCol align={"center"} maxWidth={75} widthPercent={100} pHorizontal={2} alignSelf={"center"} gap={2}>
                    <ContentTypesOverview navigate={navigate} isEducator={true} />
                    <LandingPageOverviewSections isEducator={true}/>
                    {/*<EducatorPricingSection />*/}
                    <TestimonialsComponent isEducator={true} />
                    {/*<EducatorFAQSection />*/}
                    <LearnFromExperts isEducator={true} />
                </FlexCol>
                <Footer />
            </FlexCol>
        </FlexCol>
    );
};